module.exports = __webpack_public_path__ + "static/media/method-2b.0c160cec.png";